module.exports = __webpack_public_path__ + "static/media/campus_20.b3c8f89b.jpeg";